import { render, staticRenderFns } from "./revokeRequest.vue?vue&type=template&id=f165bd7c&scoped=true&"
import script from "./revokeRequest.vue?vue&type=script&lang=js&"
export * from "./revokeRequest.vue?vue&type=script&lang=js&"
import style0 from "./revokeRequest.vue?vue&type=style&index=0&id=f165bd7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f165bd7c",
  null
  
)

export default component.exports